export const initialState = {
  privacyPolicies: [],
  privacyPolicy: {},
  publishPrivacyPolicy: {}
};
